import { render, staticRenderFns } from "./AsideMenuEditorItem.vue?vue&type=template&id=159ad565&"
import script from "./AsideMenuEditorItem.vue?vue&type=script&lang=js&"
export * from "./AsideMenuEditorItem.vue?vue&type=script&lang=js&"
import style0 from "./AsideMenuEditorItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports